import { render, staticRenderFns } from "./releaseTopic.vue?vue&type=template&id=0f4c7710&"
import script from "./releaseTopic.vue?vue&type=script&lang=js&"
export * from "./releaseTopic.vue?vue&type=script&lang=js&"
import style0 from "./releaseTopic.vue?vue&type=style&index=0&id=0f4c7710&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports